import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  makeStyles
} from '@material-ui/core'
import clsx from 'clsx'
import React, { useContext, useEffect, useState } from 'react'

import Context from '../../context'
import { addOrEditTheme } from '../../services/ClubeApi'
import ImageUploadToS3 from '../../services/ImageUpload'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function WhiteLabelForm(props) {
  const classes = useStyles()
  const { setUser } = useContext(Context)
  const data = props.location.state
  const [formData, setFormData] = useState({
    id: data?.id,
    title: data?.title || '',
    logo: data?.logo || '',
    couponsBanner: data?.couponsBanner || '',
    responsibleName: data?.responsibleName || '',
    responsiblePhone: data?.responsiblePhone || '',
    responsibleEmail: data?.responsibleEmail || '',
    primaryColor: data?.primaryColor || '#000000',
    secondColor: data?.secondColor || '#000000',
    tertiaryColor: data?.tertiaryColor || '#000000',
    primaryColorShade: data?.primaryColorShade || '#000000',
    secondColorShade: data?.secondColorShade || '#000000',
    primaryButtonBackground: data?.primaryButtonBackground || '#000000',
    primaryButtonShadow: data?.primaryButtonShadow || '#000000',
    primaryButtonTextColor: data?.primaryButtonTextColor || '#000000',
    secondButtonBackground: data?.secondButtonBackground || '#000000',
    secondButtonShadow: data?.secondButtonShadow || '#000000',
    secondButtonTextColor: data?.secondButtonTextColor || '#000000',
    WhiteLabelOffers: data?.WhiteLabelOffers || [{ offer: '' }]
  })
  const [errors, setErrors] = useState(null)
  const [loading, setLoading] = useState(false)
  const { aboutCurrentPage, setAboutCurrentPage, setShowLoadingModal } = useContext(Context)

  useEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }

    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: `${data ? 'Editar' : 'Novo'} Whitelabel`,
      buttons: [{ title: 'Voltar', pathname: '/themes' }]
    })
  }, [])

  function maskPhone(phone) {
    phone = phone.replace(/\D/g, '')
    phone = phone.replace(/^(\d)/, '($1')
    phone = phone.replace(/(.{3})(\d)/, '$1) $2')
    if (phone.length === 9) {
      phone = phone.replace(/(.{1})$/, '-$1')
    } else if (phone.length === 10) {
      phone = phone.replace(/(.{2})$/, '-$1')
    } else if (phone.length === 11) {
      phone = phone.replace(/(.{3})$/, '-$1')
    } else if (phone.length === 12) {
      phone = phone.replace(/(.{4})$/, '-$1')
    } else if (phone.length > 12) {
      phone = phone.replace(/(.{4})$/, '-$1')
    }
    return phone
  }

  function handleChange(field, index) {
    return function (e) {
      if (loading) return

      let newData = { ...formData }
      if (field === 'WhiteLabelOffers') newData[field][index].offer = e.target.value
      else if (field === 'responsiblePhone') newData[field] = maskPhone(e.target.value)
      else newData[field] = e.target.value
      setFormData(newData)
    }
  }

  function handleLogoChange(e) {
    if (loading || !e.target.files[0]) return

    setFormData({
      ...formData,
      logo: e.target.files[0]
    })
  }

  function handleCouponsBannerChange(e) {
    if (loading || !e.target.files[0]) return

    setFormData({
      ...formData,
      couponsBanner: e.target.files[0]
    })
  }

  function addOffer() {
    setFormData({
      ...formData,
      WhiteLabelOffers: [...formData.WhiteLabelOffers, { offer: '' }]
    })
  }

  function getImageDimensions(file) {
    return new Promise(resolve => {
      let image = new Image()
      image.onload = () =>
        resolve({
          width: image.width,
          height: image.height
        })
      image.src = URL.createObjectURL(file)
    })
  }

  async function checkData() {
    let errors = []
    // logo
    if (!formData.logo) errors.push('Sem imagem de logo')
    if (formData.logo instanceof File) {
      if (formData.logo.type !== 'image/png') errors.push('Logo em formato indesejável')
      let { width, height } = await getImageDimensions(formData.logo)
      if (width / height !== 56 / 12) errors.push('Logo na proporção errada')
    }
    // couponsBanner
    if (formData.couponsBanner instanceof File) {
      if (formData.couponsBanner.type !== 'image/png')
        errors.push('Banner de cupons em formato indesejável')
      let { width, height } = await getImageDimensions(formData.couponsBanner)
      if (width / height !== 2 / 1) errors.push('Banner de cupons na proporção errada')
    }
    // WhiteLabelOffers
    if (formData.WhiteLabelOffers.some(({ offer }) => /\D/.test(offer)))
      errors.push('Oferta inválida')
    if (formData.WhiteLabelOffers.length === 0) errors.push('Nenhuma oferta selecionada')
    // title
    if (!formData.title.trim()) errors.push('Sem nome do cliente')
    // responsibleName
    if (!formData.responsibleName.trim()) errors.push('Sem nome do responsável')
    // responsiblePhone
    if (!formData.responsiblePhone.trim()) errors.push('Sem contato do responsável')
    else if (!/^\d{10,11}$/.test(formData.responsiblePhone.replace(/\D/g, '')))
      errors.push('Contato do responsável inválido')
    // responsibleEmail
    if (!formData.responsibleEmail.trim()) errors.push('Sem e-mail do responsável')
    else if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        formData.responsibleEmail
      )
    )
      errors.push('E-mail do responsável inválido')
    // all colors
    let colorsProps = [
      'primaryColor',
      'secondColor',
      'tertiaryColor',
      'primaryColorShade',
      'secondColorShade',
      'primaryButtonBackground',
      'primaryButtonShadow',
      'primaryButtonTextColor',
      'secondButtonBackground',
      'secondButtonShadow',
      'secondButtonTextColor'
    ]
    if (colorsProps.some(color => !/^#[0-9a-f]{6}$/i.test(formData[color])))
      errors.push('Cor(es) inválida(s)')

    return errors.length === 0 ? false : errors
  }

  function hideErrorsModal() {
    setErrors(null)
  }

  async function saveAsDraft() {
    let errors = await checkData()
    if (errors)
      return setErrors({
        list: errors,
        situation: 3
      })

    execute(3)
  }

  async function update() {
    let errors = await checkData()
    if (errors)
      return setErrors({
        list: errors,
        situation: 1
      })

    execute(1)
  }

  async function execute(situation) {
    if (loading) return

    try {
      setShowLoadingModal(true)
      setLoading(true)
      let finalData = {
        ...formData,
        WhiteLabelOffers: formData.WhiteLabelOffers.filter(({ offer }) => !!String(offer).trim()),
        situation
      }
      if (finalData.logo instanceof File) {
        let path = await ImageUploadToS3(finalData.logo, 'images/whitelabel/')
        finalData.logo = process.env.REACT_APP_IMAGES_URL + path
      }
      if (finalData.couponsBanner instanceof File) {
        let path = await ImageUploadToS3(
          finalData.couponsBanner,
          'images/whitelabel/couponsBanner/'
        )
        finalData.couponsBanner = process.env.REACT_APP_IMAGES_URL + path
      }
      await addOrEditTheme(finalData)
      setShowLoadingModal(false)
      props.history.push('/themes')
    } catch {
      //
    }
  }

  return (
    <>
      <div className={classes.outerContainer}>
        {/* <div className={classes.header}>
          <span className={classes.title}>{data ? 'Editar' : 'Novo'} Whitelabel</span>
        </div> */}
        {loading ? <LinearProgress /> : null}
        <div className={classes.content}>
          <div className={classes.main}>
            <div className={classes.twoColumns}>
              <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
                <span>Nome do Cliente</span>
                <input value={formData.title} onChange={handleChange('title')} />
              </div>
              <div className={classes.inputGroup}>
                <span>Nome do responsável</span>
                <input
                  value={formData.responsibleName}
                  onChange={handleChange('responsibleName')}
                />
              </div>
              <div className={classes.inputGroup}>
                <span>Contato do responsável</span>
                <input
                  value={formData.responsiblePhone}
                  onChange={handleChange('responsiblePhone')}
                />
              </div>
              <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
                <span>E-mail do responsável</span>
                <input
                  value={formData.responsibleEmail}
                  onChange={handleChange('responsibleEmail')}
                />
              </div>
            </div>
            <div className={classes.divider} />
            <div className={classes.threeColumns}>
              <h4 className={clsx(classes.subtitle, classes.fullRowThreeColumns)}>
                Paleta de cores
              </h4>
              <div className={classes.inputGroup} style={{ color: formData.primaryColor }}>
                <span>Cor primária</span>
                <input
                  value={formData.primaryColor}
                  onChange={handleChange('primaryColor')}
                  maxLength={7}
                />
              </div>
              <div className={classes.inputGroup} style={{ color: formData.secondColor }}>
                <span>Cor secundária</span>
                <input
                  value={formData.secondColor}
                  onChange={handleChange('secondColor')}
                  maxLength={7}
                />
              </div>
              <div className={classes.inputGroup} style={{ color: formData.tertiaryColor }}>
                <span>Cor terciária</span>
                <input
                  value={formData.tertiaryColor}
                  onChange={handleChange('tertiaryColor')}
                  maxLength={7}
                />
              </div>
              <div className={classes.inputGroup} style={{ color: formData.primaryColorShade }}>
                <span>Cor primária - shade</span>
                <input
                  value={formData.primaryColorShade}
                  onChange={handleChange('primaryColorShade')}
                  maxLength={7}
                />
              </div>
              <div className={classes.inputGroup} style={{ color: formData.secondColorShade }}>
                <span>Cor secundária - shade</span>
                <input
                  value={formData.secondColorShade}
                  onChange={handleChange('secondColorShade')}
                  maxLength={7}
                />
              </div>
            </div>
            <div className={classes.threeColumns}>
              <h4 className={clsx(classes.subtitle, classes.fullRowThreeColumns)}>
                Botão primário
              </h4>
              <div
                className={classes.inputGroup}
                style={{ color: formData.primaryButtonBackground }}
              >
                <span>Cor de fundo</span>
                <input
                  value={formData.primaryButtonBackground}
                  onChange={handleChange('primaryButtonBackground')}
                  maxLength={7}
                />
              </div>
              <div className={classes.inputGroup} style={{ color: formData.primaryButtonShadow }}>
                <span>Cor da sombra</span>
                <input
                  value={formData.primaryButtonShadow}
                  onChange={handleChange('primaryButtonShadow')}
                  maxLength={7}
                />
              </div>
              <div
                className={classes.inputGroup}
                style={{ color: formData.primaryButtonTextColor }}
              >
                <span>Cor do texto</span>
                <input
                  value={formData.primaryButtonTextColor}
                  onChange={handleChange('primaryButtonTextColor')}
                  maxLength={7}
                />
              </div>
            </div>
            <div className={classes.threeColumns}>
              <h4 className={clsx(classes.subtitle, classes.fullRowThreeColumns)}>
                Botão secundário
              </h4>
              <div
                className={classes.inputGroup}
                style={{ color: formData.secondButtonBackground }}
              >
                <span>Cor de fundo</span>
                <input
                  value={formData.secondButtonBackground}
                  onChange={handleChange('secondButtonBackground')}
                  maxLength={7}
                />
              </div>
              <div className={classes.inputGroup} style={{ color: formData.secondButtonShadow }}>
                <span>Cor da sombra</span>
                <input
                  value={formData.secondButtonShadow}
                  onChange={handleChange('secondButtonShadow')}
                  maxLength={7}
                />
              </div>
              <div className={classes.inputGroup} style={{ color: formData.secondButtonTextColor }}>
                <span>Cor do texto</span>
                <input
                  value={formData.secondButtonTextColor}
                  onChange={handleChange('secondButtonTextColor')}
                  maxLength={7}
                />
              </div>
            </div>
          </div>
          <div className={classes.aside}>
            <div className={classes.box}>
              <h4>Logo</h4>
              <div>
                <label>
                  {formData.logo ? (
                    <img
                      className={classes.img}
                      src={(image => (image instanceof File ? URL.createObjectURL(image) : image))(
                        formData.logo
                      )}
                    />
                  ) : null}
                  <span className={classes.plainButton}>Selecionar arquivo</span>
                  <input
                    className={classes.hiddenInput}
                    type="file"
                    accept="image/png"
                    onChange={handleLogoChange}
                  />
                </label>
                <span className={classes.legend}>Arquivo .png. Proporção: 56:12</span>
              </div>
            </div>
            <div className={classes.box}>
              <h4>Banner de cupons</h4>
              <div>
                <label>
                  {formData.couponsBanner ? (
                    <img
                      className={classes.img}
                      src={(image => (image instanceof File ? URL.createObjectURL(image) : image))(
                        formData.couponsBanner
                      )}
                    />
                  ) : null}
                  <span className={classes.plainButton}>Selecionar arquivo</span>
                  <input
                    className={classes.hiddenInput}
                    type="file"
                    accept="image/png"
                    onChange={handleCouponsBannerChange}
                  />
                </label>
                <span className={classes.legend}>Arquivo .png. Proporção: 2:1</span>
              </div>
            </div>
            <div className={classes.box}>
              <h4>Grupos de ofertas</h4>
              <div>
                {formData.WhiteLabelOffers.map((item, index) => (
                  <div key={index} className={classes.inputGroup}>
                    <span>ID do grupo de oferta</span>
                    <input value={item.offer} onChange={handleChange('WhiteLabelOffers', index)} />
                  </div>
                ))}
                <button className={classes.plainButton} type="button" onClick={addOffer}>
                  Adicionar outro ID
                </button>
              </div>
            </div>
            <button className={classes.plainButton} type="button" onClick={saveAsDraft}>
              Salvar rascunho
            </button>
            <button className={classes.shadowButton} type="button" onClick={update}>
              Publicar
            </button>
          </div>
        </div>
      </div>

      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Verificação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul className={classes.ul}>
              {errors?.list?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Deseja continuar mesmo assim?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={hideErrorsModal}>
            Não
          </Button>
          <Button color="primary" onClick={() => execute(errors?.situation)}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '27px 45px',
    background: '#ece5fe'
  },
  title: {
    fontFamily: 'Matrice',
    fontSize: '24px',
    color: '#30287b'
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '45px'
  },
  main: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginRight: 30
  },
  twoColumns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '30px 20px'
  },
  threeColumns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '30px 20px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& input': {
      height: 44,
      marginTop: '10px',
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      background: 'transparent',
      border: '2px solid #30287b'
    },
    '&[style]::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: 44,
      height: 44,
      right: 0,
      bottom: 0,
      backgroundColor: 'currentColor',
      zIndex: -1
    }
  },
  fullRowTwoColumns: {
    gridColumn: '1 / 3'
  },
  fullRowThreeColumns: {
    gridColumn: '1 / 4'
  },
  divider: {
    marginTop: '45px',
    borderBottom: '2px solid #b294ff'
  },
  subtitle: {
    marginTop: '45px',
    fontFamily: 'Matrice',
    fontSize: '18px',
    color: '#30287b'
  },
  aside: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    width: 340,
    gap: '15px'
  },
  box: {
    gridColumn: '1 / 3',
    border: '2px solid #30287b',
    '& h4': {
      marginBottom: 0,
      fontSize: '14px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '44px',
      textAlign: 'center',
      textTransform: 'uppercase',
      background: '#30287b',
      borderBottom: '2px solid #30287b'
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: 'auto',
      gap: '15px',
      padding: '30px'
    }
  },
  plainButton: {
    display: 'block',
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  shadowButton: {
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#fbbb33',
    border: 'none',
    borderRadius: '2px',
    boxShadow: '4px 4px #4200f5',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto',
    backgroundColor: 'grey'
  },
  hiddenInput: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },
  legend: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#30287b',
    textAlign: 'center'
  },
  ul: {
    margin: '15px 0'
  }
})

export default WhiteLabelForm
